import { render, staticRenderFns } from "./OrganismEscalationEvents.vue?vue&type=template&id=afde7830&scoped=true&"
import script from "./OrganismEscalationEvents.vue?vue&type=script&lang=js&"
export * from "./OrganismEscalationEvents.vue?vue&type=script&lang=js&"
import style0 from "./OrganismEscalationEvents.vue?vue&type=style&index=0&id=afde7830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afde7830",
  null
  
)

export default component.exports